/**
 * Deployment environment domain shared by both apps.
 *
 * Original locations: (identical enum values, verified):
 *  - web: apps/web/environment.ts (Environment)
 *  - api: apps/api/src/environment.ts (Environment)
 *
 * Only the enum and the pure, env-var-free predicates live here. The helpers that
 * read process.env (getEnv, getEnvironmentName, environment, isClientFacingEnvironment)
 * stay app-local so each runtime keeps its own env-access strategy (Vite-safe vs direct).
 */
/** The deployment environment a build/runtime is targeting. */
export var Environment;
(function (Environment) {
    Environment["DEV"] = "dev";
    Environment["PROD"] = "prod";
    Environment["BETA"] = "beta";
    Environment["LOCAL"] = "local";
    Environment["VERIFY_VAL"] = "verify-val";
    Environment["VAL_SANDBOX"] = "val-sandbox";
})(Environment || (Environment = {}));
/** Environments exposed to customers (as opposed to internal dev/local). */
export const clientFacingEnvironments = [
    Environment.PROD,
    Environment.BETA,
    Environment.VERIFY_VAL,
    Environment.VAL_SANDBOX,
];
/** Whether a given environment name is one customers can reach. */
export const isClientFacingEnvironmentName = (environmentName) => clientFacingEnvironments.includes(environmentName);
//# sourceMappingURL=environment.js.map